import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { fetchUserAssignmentsList } from "../../../../redux/actions/userAssignmentsListActions";
import {
  myCoursesSortMethods,
  userAssignmentListTypes
} from "../../../../constants";
import MyCourses from "../../../../views/Library/MyItems/MyCourses";
import { makeGetEntities } from "../../../../redux/selectors/selectors";
import { ExpandedAssignmentsProvider } from "../../../../context/ExpandedAssignmentsContext";

const selector = makeGetEntities();

const MyCoursesContainer = ({ assignments, loading }) => {
  const [sortByOption, setSortByOption] = useState(myCoursesSortMethods[2]);

  const dispatch = useDispatch();

  const loadAssignments = () => {
    const sortOrder = sortByOption.value;
    dispatch(
      fetchUserAssignmentsList({
        type: userAssignmentListTypes.self,
        order: sortOrder
      })
    );
  };

  useEffect(() => {
    loadAssignments();
  }, [sortByOption]);

  const handleSortChange = newSortByOption => {
    setSortByOption(myCoursesSortMethods.find(x => x === newSortByOption));
  };

  return (
    <ExpandedAssignmentsProvider>
      <MyCourses
        courses={assignments}
        sortOptions={myCoursesSortMethods}
        handleSort={handleSortChange}
        sortOrder={sortByOption}
        loading={loading}
        refetchAssignments={loadAssignments}
      />
    </ExpandedAssignmentsProvider>
  );
};

const mapStateToProps = state => ({
  assignments: selector(state.userAssignmentsListState, {
    type: "userAssignment",
    id:
      state.userAssignmentsListState.displayedCourses[
        userAssignmentListTypes.self
      ]
  }),
  loading:
    state.userAssignmentsListState.loadingState[userAssignmentListTypes.self]
});

export default connect(mapStateToProps)(MyCoursesContainer);
